(() => {
  function initProductCardCarousel(root) {
    if (!root || root.dataset.pcarouselReady === '1') return;

    const track = root.querySelector('[data-pcarousel-track]');
    const dotsWrap = root.querySelector('[data-pcarousel-dots]');
    if (!track) {
      root.dataset.pcarouselReady = '1';
      return;
    }

    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.pcarousel__dot')) : [];
    const url = root.dataset.pcarouselUrl || root.closest('a')?.href;

    // jeśli nie ma kropek albo linku - nic nie psujemy
    if (!url) {
      root.dataset.pcarouselReady = '1';
      return;
    }

    const clamp = (n, min, max) => Math.min(Math.max(n, min), max);

    const getIndexFromScroll = () => {
      if (!dots.length) return 0;
      const w = track.clientWidth || 1;
      const idx = Math.round(track.scrollLeft / w);
      return clamp(idx, 0, dots.length - 1);
    };

    const setActive = (index) => {
      if (!dots.length) return;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    };

    // swipe/scroll -> aktywna kropka
    let rafId = null;
    track.addEventListener(
      'scroll',
      () => {
        if (!dots.length) return;
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => setActive(getIndexFromScroll()));
      },
      { passive: true }
    );

    // klik w kropkę -> przewiń do slajdu
    if (dotsWrap && dots.length) {
      dotsWrap.addEventListener('click', (e) => {
        const btn = e.target.closest('.pcarousel__dot');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        const index = Number(btn.dataset.index || 0);
        track.scrollTo({ left: (track.clientWidth || 1) * index, behavior: 'smooth' });
        setActive(index);
      });
    }

    // ✅ TAP NA ZDJĘCIE -> OTWÓRZ PRODUKT (ale nie przy swipe)
    let startX = 0;
    let startY = 0;
    let moved = false;
    const MOVE_TOL = 8; // px

    const isInDots = (el) => !!el.closest?.('.pcarousel__dots');

    track.addEventListener('pointerdown', (e) => {
      // jak ktoś trafia w kropki, to nie mieszamy
      if (isInDots(e.target)) return;

      startX = e.clientX;
      startY = e.clientY;
      moved = false;
    });

    track.addEventListener('pointermove', (e) => {
      if (!startX && !startY) return;

      const dx = Math.abs(e.clientX - startX);
      const dy = Math.abs(e.clientY - startY);

      if (dx > MOVE_TOL || dy > MOVE_TOL) moved = true;
    }, { passive: true });

    const onPointerUp = (e) => {
      // jak klik w kropki, to nie otwieraj produktu
      if (isInDots(e.target)) return;

      // jeśli to nie był swipe -> otwórz
      if (!moved) {
        window.location.href = url;
      }

      startX = 0;
      startY = 0;
      moved = false;
    };

    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', () => {
      startX = 0;
      startY = 0;
      moved = false;
    });

    window.addEventListener('resize', () => setActive(getIndexFromScroll()));

    // start
    setActive(getIndexFromScroll());
    root.dataset.pcarouselReady = '1';
  }

  function initAll() {
    document.querySelectorAll('[data-pcarousel]').forEach(initProductCardCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Prestige: filtry / infinite scroll / dociąganie produktów
  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes?.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches?.('[data-pcarousel]')) initProductCardCarousel(node);
        node.querySelectorAll?.('[data-pcarousel]').forEach(initProductCardCarousel);
      });
    }
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();